module.exports = __webpack_public_path__ + "static/img/aigcsp.318aa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/aigcsp.png
// module id = +0Ip
// module chunks = 1